import { helpImagesActions } from '../../services';

export const helpImagesReducer = ( state = {}, action ) => {
  switch ( action.type ) {
    case helpImagesActions.LOAD:
      return action && action.data && action.data.reduce ? action.data.reduce( ( current, item ) => {
        current[item.toLowerCase()] = true;
        return current;
      }, {} ) : state;
    default:
      return state;
  }
};
